import React from 'react'

export const Logo = () => {
    return (
        <svg
            width='120'
            height='40'
            viewBox='0 0 205 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0 0.621471V38.9266C6.21981 39.435 10.8989 39.6045 15.7492 39.6045C34.1234 39.6045 41.8838 33.7288 41.8838 19.774C41.8838 5.9887 33.781 0 15.7492 0C11.1842 0 5.42093 0.169492 0 0.621471ZM17.1187 8.58757C26.2487 8.58757 30.0149 11.6949 30.0149 19.774C30.0149 27.7401 26.534 31.1299 17.1187 31.1299C14.8933 31.1299 13.2385 31.0734 11.2984 30.9605V8.81356C13.2385 8.64407 14.9504 8.58757 17.1187 8.58757Z'
                fill='white'
            />
            <path
                d='M45.3214 26.1582C45.3214 34.4633 49.8864 40 62.326 40C74.7656 40 79.3306 34.4633 79.3306 26.1582C79.3306 17.8531 74.7656 12.3164 62.326 12.3164C49.8864 12.3164 45.3214 17.8531 45.3214 26.1582ZM62.326 19.435C66.7198 19.435 68.5458 21.8079 68.5458 26.2147C68.5458 30.6215 66.7198 32.9379 62.326 32.9379C57.9893 32.9379 56.1633 30.6215 56.1633 26.2147C56.1633 21.8079 57.9893 19.435 62.326 19.435Z'
                fill='white'
            />
            <path
                d='M94.3019 0.225989H83.7454V38.983H94.3019V32.8814L99.0952 29.1525L103.489 34.0678C107.255 38.3051 111.249 39.0396 118.211 39.0396L118.725 30.9605C114.502 30.904 112.334 30.0565 109.652 27.0621L106.456 23.3898L119.01 13.3898H105.315L94.3019 22.7119V0.225989Z'
                fill='white'
            />
            <path
                d='M133.142 0.225989H122.586V27.9661C122.586 36.2712 126.466 39.2655 133.998 39.2655C135.425 39.2655 136.965 39.209 138.677 38.983V30.791C138.164 30.8475 137.593 30.904 137.137 30.904C133.941 30.904 133.142 29.2655 133.142 26.1582V0.225989Z'
                fill='white'
            />
            <path
                d='M151.736 28.2486H174.732C174.675 16.7232 169.311 12.3729 158.184 12.3729C146.315 12.3729 140.723 17.8531 140.723 26.2147C140.723 34.5198 146.258 40 157.328 40C163.833 40 170.11 39.096 174.447 34.0113L166.803 30.5088C164.461 32.8629 162.635 33.3333 158.983 33.3333C155.045 33.3333 152.478 31.6384 151.736 28.2486ZM158.64 18.4181C161.836 18.4181 164.175 19.7175 164.461 23.1073H151.964C152.82 20.0565 155.16 18.4181 158.64 18.4181Z'
                fill='white'
            />
            <path
                d='M176.241 13.3898V20.226H181.034V27.4011C181.034 35.7627 185.028 40 194.272 40C197.924 40 201.862 39.209 205 37.6271L203.345 30.339C201.633 31.4124 199.351 32.2034 197.297 32.2034C193.131 32.2034 191.704 29.887 191.704 25.6497V20.226H203.573V13.3898H191.704V3.22034L181.034 5.36723V13.3898H176.241Z'
                fill='white'
            />
        </svg>
    )
}
